import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  checkUberHealthServiceAvailability,
  resetUberHealthServiceAvailability,
} from '../store/rides';

const isPickupAddressValid = (currentValues) =>
  Boolean(
    currentValues?.pickupAddressDetails?.coordinates &&
      currentValues?.pickupAddressDetails?.route &&
      currentValues?.pickupAddressDetails?.streetNumber &&
      currentValues?.pickupAddressDetails?.state &&
      currentValues?.pickupAddressDetails?.county &&
      currentValues?.pickupAddressDetails?.placeId &&
      currentValues?.pickupAddressDetails?.postalCode
  );

const isDestinationAddressValid = (currentValues) =>
  Boolean(
    currentValues?.destinationAddress?.coordinates &&
      currentValues?.destinationAddress?.route &&
      currentValues?.destinationAddress?.streetNumber &&
      currentValues?.destinationAddress?.state &&
      currentValues?.destinationAddress?.county &&
      currentValues?.destinationAddress?.placeId &&
      currentValues?.destinationAddress?.postalCode
  );

/**
 * Runs Uber Health trip estimates in the background when pickup and destination are complete (Create Ride step 3).
 * Does not set rides.loading — only uberHealthRouteAvailable / uberHealthRouteCheckPending.
 */
export const useUberHealthServiceAvailability = (currentValues, allowCheck) => {
  const dispatch = useDispatch();

  const pickupOk = useMemo(() => isPickupAddressValid(currentValues), [currentValues]);
  const destOk = useMemo(() => isDestinationAddressValid(currentValues), [currentValues]);

  useEffect(() => {
    return () => {
      dispatch(resetUberHealthServiceAvailability());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!allowCheck) {
      dispatch(resetUberHealthServiceAvailability());
      return;
    }

    if (!pickupOk || !destOk || !currentValues) {
      dispatch(resetUberHealthServiceAvailability());
      return;
    }

    const pickup = currentValues.pickupAddressDetails.coordinates;
    const dest = currentValues.destinationAddress.coordinates;

    dispatch(
      checkUberHealthServiceAvailability({
        pickupLat: pickup.lat,
        pickupLng: pickup.lng,
        dropoffLat: dest.lat,
        dropoffLng: dest.lng,
        roundTrip: Boolean(currentValues.isRoundtrip),
      })
    );
  }, [
    allowCheck,
    pickupOk,
    destOk,
    currentValues?.pickupAddressDetails?.coordinates?.lat,
    currentValues?.pickupAddressDetails?.coordinates?.lng,
    currentValues?.destinationAddress?.coordinates?.lat,
    currentValues?.destinationAddress?.coordinates?.lng,
    currentValues?.isRoundtrip,
    dispatch,
  ]);
};
